import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const dynamicLeadFormAtom = atom({
  key: RecoilAtomKey.dynamicLeadFormKey,
  default: [],
});

const leadDetailObjAtom = atom({
  key: RecoilAtomKey.leadDetailObjKey,
  default: {},
});

const leadB2b2cDetailObjAtom = atom({
  key: RecoilAtomKey.leadB2b2cDetailObjkey,
  default: {},
});

const leadAllCountsAtom = atom({
  key: RecoilAtomKey.leadAllCountsKey,
  default: {},
});

// const isLeadFormValidateAtom = atom({
//   key: RecoilAtomKey.isLeadFormValidateKey,
//   default: false,
// });

const B2b2cFormErrorAtom = atom({
  key: RecoilAtomKey.B2b2cFormErrorKey,
  default: {},
});

const referenceFieldAtom = atom({
  key: RecoilAtomKey.referenceFieldKey,
  default: [{ number: '', designation: '', name: '' }],
});

const userInfoByNumberAtom = atom({
  key: RecoilAtomKey.userInfoByNumberKey,
  default: {},
});

const formEnableDisableAtom = atom({
  key: RecoilAtomKey.formEnableDisableKey,
  default: false,
});

const leadFormQuickTemplateAtom = atom({
  key: RecoilAtomKey.leadFormQuickTemplateKey,
  default: [],
});

const userInfoFormEnableDisableAtom = atom({
  key: RecoilAtomKey.userInfoFormEnableDisableKey,
  default: {},
});

const knowlarityApiResponseAtom = atom({
  key: RecoilAtomKey.knowlarityApiResponseKey,
  default: {},
});

const userRawLeadFormDataAtom = atom({
  key: RecoilAtomKey.userRawLeadFormDataKey,
  default: {},
});
const userStaticFormData = [
  {
    column_name: 'supplier_id',
    alias_name: 'supplier_id',
    field_type: 'String',
    field_options: '',
    is_primary_key: 1,
    is_required: 1,
    entry_id: 1,
    Is_visible_on_frontend: 0,
    campaign_id: '',
    campaign_name: '',
    value: '',
  },
  {
    column_name: 'person_name',
    alias_name: 'person_name',
    field_type: 'String',
    field_options: '',
    is_primary_key: 0,
    is_required: 0,
    entry_id: 2,
    Is_visible_on_frontend: 1,
    campaign_id: '',
    campaign_name: '',
    value: '',
  },
  {
    column_name: 'State',
    alias_name: 'state',
    field_type: 'String',
    field_options: '',
    is_primary_key: 0,
    is_required: 0,
    entry_id: 2,
    Is_visible_on_frontend: 1,
    campaign_id: '',
    campaign_name: '',
    value: '',
  },
  {
    column_name: 'City',
    alias_name: 'city',
    field_type: 'String',
    field_options: '',
    is_primary_key: 0,
    is_required: 0,
    entry_id: 2,
    Is_visible_on_frontend: 1,
    campaign_id: '',
    campaign_name: '',
    value: '',
  },
  {
    column_name: 'Area',
    alias_name: 'area',
    field_type: 'String',
    field_options: '',
    is_primary_key: 0,
    is_required: 0,
    entry_id: 2,
    Is_visible_on_frontend: 1,
    campaign_id: '',
    campaign_name: '',
    value: '',
  },
];

const phoneNumberAllLeadsAtom = atom({
  key: RecoilAtomKey.phoneNumberAllLeadsKey,
  default: { leads: [], pagination: {} },
});

export {
  dynamicLeadFormAtom,
  leadDetailObjAtom,
  leadAllCountsAtom,
  leadB2b2cDetailObjAtom,
  // isLeadFormValidateAtom,
  B2b2cFormErrorAtom,
  referenceFieldAtom,
  userInfoByNumberAtom,
  formEnableDisableAtom,
  leadFormQuickTemplateAtom,
  userInfoFormEnableDisableAtom,
  knowlarityApiResponseAtom,
  userStaticFormData, //constant
  userRawLeadFormDataAtom,
  phoneNumberAllLeadsAtom,
};
